// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3219":"8687675c15edc227","5771":"41f6de68530b5373"}[chunkId] + ".js";
};